import { useContext, useEffect } from "react";
import CmsContext from "../Context/CmsContext";

const EmptyPage = () => {
    return <></>
}

export default EmptyPage;